import { createGlobalStyle } from 'styled-components'
import { appResource } from '@jarvis.oddle/core/env'

export default createGlobalStyle`
  /* stylelint-disable at-rule-empty-line-before */
  @font-face {
    font-family: '王漢宗細黑體繁';
    src: url(${appResource('/customFonts/HanWangHei-Light.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '王漢宗細圓體繁';
    src: url(${appResource('/customFonts/HanWangYen-Light.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '王漢宗粗明體繁';
    src: url(${appResource('/customFonts/HanWangMing-Bold.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: ' 小米兰亭简';
    src: url(${appResource('/customFonts/MiLanTing-Bold.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: '腾翔嘉丽细圆简';
    src: url(${appResource('/customFonts/TensentypeJiaLiXiYuan.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '腾祥睿黑简';
    src: url(${appResource('/customFonts/TensentypeRuiHeiJ.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '王漢宗波卡體繁一空陰';
    src: url(${appResource('/customFonts/WCL-03.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '王漢宗粗圓體繁一雙空';
    src: url(${appResource('/customFonts/WCL-09.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '瀨戶字體繁';
    src: url(${appResource('/customFonts/SetoFont-1.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '田氏方筆刷體繁';
    src: url(${appResource('/customFonts/TianShiFangBiShuaTiFan-1.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '田氏细笔刷體繁';
    src: url(${appResource('/customFonts/田氏细笔刷体繁.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '站酷快乐简体';
    src: url(${appResource('/customFonts/站酷快乐体.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '站酷酷黑';
    src: url(${appResource('/customFonts/站酷快乐体.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '站酷小薇字体简体';
    src: url(${appResource('/customFonts/ZhanKuXiaoLOGOTi-2.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Aa晚风';
    src: url(${appResource('/customFonts/AaWanFeng-2.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Aa荷包鼓鼓';
    src: url(${appResource('/customFonts/AaHeBaoGuGu-2.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Adobe Garamond Pro';
    src: url(${appResource('/customFonts/Adobe-Garamond-Pro_2012.woff')}) format('woff');
    font-weight: normal;
  }
  /* stylelint-enable at-rule-empty-line-before */
`
